module.exports = __webpack_public_path__ + "static/img/social_index_banner_h5.86caded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/social_index_banner_h5.png
// module id = 4QAR
// module chunks = 34